<template>
    <div>
        <el-dialog custom-class="product-dialog-class" :title="title" :visible.sync="dialogVisible" @close="close" width="800px" :close-on-click-modal="false">
            <div class="dialog-box">
                <div class="dialog-block-box" >
                    <el-divider content-position="left">产品信息</el-divider>
                    <el-form :model="productForm" :rules="rules" ref="form" size="mini" label-position="right" label-width="100px">
                        <el-form-item label="产品编码:" prop="product_code">
                            <el-input :disabled="type=='edit'" v-model="productForm.product_code" type="text" placeholder="请输入产品名称" size="mini" class="dialog-div-input"></el-input>
                        </el-form-item>      
                        <el-form-item label="卡号前缀:" prop="card_prefix">
                            <el-input v-model="productForm.card_prefix" type="text" placeholder="请输入卡号前缀" size="mini" class="dialog-div-input"></el-input>
                        </el-form-item> 
                        <el-form-item label="产品名称:" prop="product_name">
                            <el-input v-model="productForm.product_name" type="text" placeholder="请输入产品名称" size="mini" class="dialog-div-input"></el-input>
                        </el-form-item>    
                        <el-form-item label="产品状态:" prop="status">
                            <el-switch
                                v-model="productForm.status"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="开启"
                                inactive-text="关闭">
                            </el-switch>    
                        </el-form-item>   
                    </el-form>
                </div> 
                <div class="dialog-block-box" >
                    <el-divider content-position="left">面值配置</el-divider>
                    <div class="add-face-value-block">                    
                        <el-button class="add-face" size="mini" type="primary" icon="el-icon-plus" @click="addFaceValue">添加配置</el-button>
                    </div>
                    <div class="face-list-box">
                        <el-table :data="productForm.denominations" style="width: 100%;">
                            <el-table-column label="面值" prop="value" width="100px"></el-table-column>
                            <el-table-column label="商品链接" prop="goods_url"></el-table-column>
                            <el-table-column label="商品图片" prop="product_image" width="100px">
                                <template slot-scope="scope">
                                    <el-image :src="scope.row.product_image" ></el-image>
                                    <!-- <div class="face-value-list">{{scope.row}}                               -->
                                    <!-- </div> -->
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100px">
                                <template slot-scope="scope">
                                    <div class="action-btn-box">
                                        <el-button class="mr20" type="text" size="small" @click="editMoneyValue(scope.row,scope.$index)">编辑</el-button>
                                        <el-popconfirm title="确认删除该配置？" @confirm = "deleteFaceValue(scope.$index)">
                                            <el-button slot="reference" class="text-btn-danger" type="text" size="small">删除</el-button>
                                        </el-popconfirm>
                                        <!-- <el-button class="text-btn-danger" type="text" size="small" @click="deleteFaceValue(scope.$index)">删除</el-button> -->
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    
                </div> 
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="close">取 消</el-button>
                <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="loading">确 定</el-button>
            </div>
        </el-dialog>
        <div>
            <MoneyValueConfig v-if="dialog.moneyValue.visible" class="money-config" ref="moneyConfig" 
                :title="dialog.moneyValue.title" 
                :type="dialog.moneyValue.type"
                :dialogVisible="dialog.moneyValue.visible" 
                :loading="dialog.moneyValue.loading" 
                :fromData="dialog.moneyValue.formData" 
                :editIndex="dialog.moneyValue.editIndex"
                @sure="suerFaceValue" 
                @close="closeFaceValue" 
            >
            </MoneyValueConfig>
        </div>
    </div>
</template>
<script>
import MoneyValueConfig from "@/components/cardPwdManage/moneyValueConfig.vue"
    export default {
        props:{
            dialogVisible:{
                type: Boolean,
                default:false,
            },
            title:{
                type: String,
                default: ''
            },
            formData:{
                type: Object,
                default: function () {
                    return {}
                }
            },
            loading:{  
                type: Boolean,
                default: false
            },
            type:{
                type: String,
                default: ''
            }
        },
        components:{
            MoneyValueConfig
        },
        data() {
            return {
                productForm:{},
                rules:{
                    product_code:[{ required: true, message: '请输入产品编码', trigger: 'blur' }],
                    product_name:[{ required: true, message: '请输入产品名称', trigger: 'blur' },
                    ],                  
                    card_prefix:[{ required: true, message: '请输入卡号前缀', trigger: 'blur' },
                        { pattern: /^\d{1,6}$/, message: '卡号前缀必须是1到6位数字',trigger: 'blur'}
                    ],
                },
                dialog:{
                    moneyValue:{
                        visible:false,
                        loading:false,
                        formData:{  
                            value: 0,
                            goods_url: '',
                            product_image:''
                        },
                        editIndex: -1,
                        title: '添加面值配置',
                        type:'add'
                    }
                },
                
            }
        },
        mounted() {
            // this.productForm= this.formData
            for (const key in this.formData) {
                this.$set(this.productForm, key, this.formData[key]);
            }
            for(const key in this.formData.denominations){
                this.$set(this.productForm.denominations, key, this.formData.denominations[key]);
            }
        },
        methods:{
            close(){
                this.$emit('close');
            },
            async sure(){
                // 1. 校验父表单
                // const parentValid = await new Promise(resolve => {
                //     this.$refs.form.validate(v => resolve(v));
                // });

                // // 2. 并行校验所有子表单
                // const childValidList = await Promise.all(
                //     this.$refs.moneyConfig.map(child =>
                //         new Promise(resolve => {
                //             child.$refs.form.validate(v => resolve(v));
                //         })
                //     )
                // );
                // const allChildValid = childValidList.every(v => v === true);
                // if (!allChildValid || !parentValid) {
                //     return;
                // }
                // 3. 父子表单都通过

                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$emit("sure", this.productForm);                                    
                    } else {
                        return false;
                    }
                });
                

            },
            //增加面值
            addFaceValue(){
                this.dialog.moneyValue.visible = true;                
                this.dialog.moneyValue.title ="添加面值配置"
                this.dialog.moneyValue.type ="add"
                this.dialog.moneyValue.editIndex =-1
                this.dialog.moneyValue.formData= {
                    value : 0,
                    goods_url:'',
                    product_image:[],
                }
                // let denom={
                //     value: "",
                //     goods_url: "",
                //     status: 1
                // }
                // this.productForm.denominations.push(denom);
            },
            //删除面值
            deleteFaceValue(index){
                if(this.productForm.denominations.length==1){
                    this.$message({
                        message: '请至少保留一个面值',
                        type: 'warning'
                    });
                    return;
                }
                this.$emit('deleteFaceValue',index)
                
            },
            closeFaceValue(){
                this.dialog.moneyValue.visible = false;
            },
            suerFaceValue(form,editIndex){
                
                let product_image = form.product_image[0];
                form.product_image = product_image;
                if(editIndex !=-1){
                    let obj = {...form}
                    this.productForm.denominations.splice(editIndex,1,obj)
                }else{
                    this.productForm.denominations.push(form);
                }
               
                this.closeFaceValue();
                // this.$emit('suerFaceValue');
            },
            editMoneyValue(item,index){                
                this.dialog.moneyValue.visible = true;
                this.dialog.moneyValue.editIndex = index;
                this.dialog.moneyValue.title ="编辑面值配置"
                this.dialog.moneyValue.type ="edit"
                let formData = item;
                formData.product_image =[item.product_image]
                this.dialog.moneyValue.formData = JSON.parse(JSON.stringify(formData));


            }
        }
    }
</script>
<style lang="scss" scoped>
.product-dialog-class{
    .money-config{
        margin-bottom: 16px;
    }
    .add-face-value-block{
        padding: 16px 20px;
        border-bottom: 1px solid #ebeef5;
        background-color: #fafcff;
         .add-face{
        // width: 136px;
        }
    }
   
}
    
</style>